var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9765 4.5C13.7137 4.64382 14.4454 4.96892 14.9765 5.5C15.5076 6.03108 15.8327 6.76284 15.9765 7.5M13.4765 1C15.008 1.17014 16.3862 1.91107 17.4765 3C18.5668 4.08893 19.3044 5.46869 19.4765 7M19.476 14.4767V17.1864C19.4802 18.2223 18.5488 19.0873 17.503 18.9929C8.47656 19 1.47656 11.935 1.48363 2.96919C1.38944 1.92895 2.25014 1.00106 3.28467 1.00009H5.99981C6.43904 0.995773 6.86485 1.151 7.19788 1.43684C8.14469 2.24949 8.75369 5.00777 8.51938 6.10428C8.33644 6.96036 7.47347 7.55929 6.88676 8.14484C8.17514 10.4062 10.0512 12.2785 12.317 13.5644C12.9037 12.9788 13.5039 12.1176 14.3616 11.935C15.462 11.7008 18.238 12.3106 19.0474 13.264C19.3345 13.6021 19.487 14.0337 19.476 14.4767Z",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavContact);
export default __webpack_public_path__ + "static/media/nav-contact.7509c5d3ff2f7b046886c49571f94bbb.svg";
export { ForwardRef as ReactComponent };